import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import ReactDOM from 'react-dom';
import { window, document } from '../../../../helpers/BrowserHelpers';
import { ChevronIcon } from '../../../../components/Icons';
import Topbar from './Topbar';
var IMAGE_LIGHTBOX_ZINDEX = 5;

var MediaLightbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MediaLightbox, _React$Component);

  function MediaLightbox(props) {
    var _this;

    _classCallCheck(this, MediaLightbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaLightbox).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onPluginStateChange", function () {
      var pluginState = _this.props.pluginStore.getItem('state');

      _this.setState(pluginState);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (!_this.state.show) {
        return;
      }

      switch (event.key) {
        case 'Escape':
          event.preventDefault();
          return _this.onClose();

        case 'ArrowLeft':
          event.preventDefault();
          return _this.goPrevious();

        case 'ArrowRight':
          event.preventDefault();
          return _this.goNext();

        default:
          return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      event.stopPropagation();
      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (event) {
      event.stopPropagation();
      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onClickBackground", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.onClose();

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onClickImage", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.goNext();

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      _this.props.editor.closeLightbox();
    });

    _defineProperty(_assertThisInitialized(_this), "goNext", function () {
      _this.props.editor.goLightboxNext();
    });

    _defineProperty(_assertThisInitialized(_this), "goPrevious", function () {
      _this.props.editor.goLightboxPrevious();
    });

    _this.state = _this.props.pluginStore.getItem('state');
    return _this;
  }

  _createClass(MediaLightbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.onKeyDown);
      this.props.pluginStore.subscribeToItem('state', this.onPluginStateChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown);
      this.props.pluginStore.unsubscribeFromItem('state', this.onPluginStateChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getUser = _this$props.getUser,
          editor = _this$props.editor;
      var _this$state = this.state,
          index = _this$state.index,
          medias = _this$state.medias,
          show = _this$state.show;
      var mediaData = medias[index];

      if (!show || !mediaData) {
        return false;
      }

      return ReactDOM.createPortal(React.createElement("div", {
        // Prevent bubbling events to hoc plugins (e.g resizeable)
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        className: "position-fixed white flexbox flexbox-column",
        style: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: IMAGE_LIGHTBOX_ZINDEX,
          background: 'rgba(0, 0, 0, .85)'
        }
      }, React.createElement(Topbar, {
        onToggle: this.onClose,
        mediaData: mediaData,
        getUser: getUser,
        index: index
      }), React.createElement("div", {
        className: "flexbox-grow padding-top-large padding-left-large padding-right-large center-text flexbox flexbox-column flexbox-justify-center flexbox-align-center margin-bottom-medium",
        style: {
          height: '100%'
        },
        onClick: this.onClose
      }, this.props.renderItem(editor, mediaData)), medias.length > 1 && React.createElement("div", {
        className: "flexbox flexbox-no-shrink flexbox-no-grow margin-bottom-medium center-text"
      }, React.createElement("div", {
        className: "flexbox flexbox-align-center margin-left-auto margin-right-auto no-selection"
      }, React.createElement("div", {
        className: "padding-normal pointer",
        onClick: this.goPrevious
      }, React.createElement(ChevronIcon, {
        style: {
          transform: 'rotate(180deg)'
        },
        size: 16
      })), React.createElement("div", {
        className: "padding-horizontal-medium font-weight-bold center-text",
        style: {
          minWidth: 80
        }
      }, index + 1, "/", medias.length), React.createElement("div", {
        className: "padding-normal pointer",
        onClick: this.goNext
      }, React.createElement(ChevronIcon, {
        size: 16
      }))))), document.body);
    }
  }]);

  return MediaLightbox;
}(React.Component);

export default MediaLightbox;